import React from 'react';

import Show from 'components/Show';
import Icon from 'components/Misc/Icon';
import Progress from 'components/Misc/Progress';
import { Title } from 'components/Misc/Typography';

import Webinar from 'containers/Student/Webinars/Read/Webinar';

import { useStudentWebinarStore } from 'store/student/useStudentWebinarStore';

const Active = ({ progress }) => {
	// Use student's webinar store
	const active = useStudentWebinarStore(state => state.active);

	return (
		<>
			<div className="flex items-center space-x-2">
				<Icon
					icon="voice_chat"
					className="text-amber-500 text-xl"
				/>

				<Title
					title="Tuvākie vebināri"
					className="text-xl flex-1"
				/>
			</div>

			{/* Show progress */}
			<Progress progress={progress} />

			{/* Show nothing if there are no webinars */}
			<Show if={!progress && !active?.length}>
				<div className="py-4 flex flex-col items-center space-y-2">
					<Icon
						icon="celebration"
						className="text-4xl text-neutral-400 dark:text-neutral-600"
					/>
				
					<div className="font-base text-neutral-400 dark:text-neutral-600">
						Pašlaik Tev nav plānotu vebināru!
					</div>
				</div>
			</Show>
			
			{/* Show active webinars */}
			<Show if={active?.length && !progress}>
				<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
					{active?.map(webinar =>
						<Webinar key={webinar.id} webinar={webinar} />
					)}
				</div>
			</Show>
		</>
	);
};

export default Active;